import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RequestBodyConverter } from '../RequestBodyConverter';
import { useParams } from 'react-router-dom';
import ConsumableForm from './ConsumableForm';
import { showConsumableApi, updateConsumableApi, clearEditedConsumable } from './consumableSlice';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import uploadImage from '~/api/uploadImage';

function ConsumableUpdate() {
    const { id } = useParams();
    const [resetCount, setResetCount] = useState(0);
    const { editedModel: initialValues, pictureAttributeNames } = useSelector((state) => state.itemSaga.consumable);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formSubmit = async (rawValues) => {
        let values = new RequestBodyConverter(rawValues);
        await values.convertPictures(rawValues, pictureAttributeNames);
        values = values.data;
        dispatch(clearApiValidationErrors()); //clear current api validation errors if any.
        await uploadImage(rawValues, pictureAttributeNames, 'consumables');
        dispatch(updateConsumableApi({ navigate, values, id }));
    };

    useEffect(() => {
        dispatch(showConsumableApi({ navigate, id }));

        return () => dispatch(clearEditedConsumable());
    }, []);

    return (
        <ConsumableForm
            resetCount={resetCount}
            setResetCount={setResetCount}
            pictureAttributeNames={pictureAttributeNames}
            initialValues={initialValues}
            formSubmit={formSubmit}
        />
    );
}

export default ConsumableUpdate;
